import React, { useState, useEffect, useRef } from 'react';
import '../CSS/homepage.css';
import BackgroundScene from '../components/ui/aurora-section-hero';
import { ShinyButton } from '../components/ui/shiny-button';
import ScrollExpandMedia from '../components/ScrollExpandMedia';
import MainPageContent from '../components/MainPageContent';
import MainPageHomeSection from '../components/MainPageHomeSection';

const HomePage = () => {
  const scrollExpandRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  const calculateBeams = () => {
    if (typeof window === 'undefined') return 120;
    return Math.max(20, Math.floor(window.innerWidth / 15));
  };

  const [beamCount, setBeamCount] = useState(calculateBeams());

  useEffect(() => {
    const handleResize = () => {
      setBeamCount(calculateBeams());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleScrollToTop = () => {
    scrollExpandRef.current?.resetTransition();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isAuroraExiting = scrollProgress > 0.12;

  const landingOverlay = (
    <div className="landing-overlay">
      <div className="header-container">
        <div className="header-content">
          <ShinyButton
            href="https://vit.ac.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="vit-logo-button"
          >
            <img src="/VIT Logo.webp" alt="VIT Logo" className="vit-logo" />
          </ShinyButton>
        </div>
      </div>

      <div className="studentwelfare-container">
        <div className="studentwelfare-content">
          <ShinyButton
            href="https://vit.ac.in/campuslife/studentswelfare"
            target="_blank"
            rel="noopener noreferrer"
            className="osw-button"
          >
            Office of Students' Welfare
          </ShinyButton>
        </div>
      </div>

      {/* Decorative scroll hint — non-interactive, reuses the shiny
          button styling already injected on the landing. */}
      <div className="scroll-indicator-wrap" aria-hidden="true">
        <div className="shiny-cta scroll-indicator-btn">
          <i className="scroll-indicator-arrow" />
        </div>
      </div>
    </div>
  );

  return (
    <div className="homepage-merged">
      <ScrollExpandMedia
        ref={scrollExpandRef}
        titleLeft="Welcome to"
        titleRight="IEEE TEMS"
        renderBackground={
          <BackgroundScene beamCount={beamCount} isExiting={isAuroraExiting} />
        }
        landingOverlay={landingOverlay}
        onProgressChange={setScrollProgress}
        portalContent={
          <MainPageHomeSection
            embedded
            scaleInnerText
            onScrollToTop={handleScrollToTop}
          />
        }
        expandedPortalContent={
          <MainPageHomeSection onScrollToTop={handleScrollToTop} />
        }
      >
        <MainPageContent sectionsOnly onScrollToTop={handleScrollToTop} />
      </ScrollExpandMedia>
    </div>
  );
};

export default HomePage;
